import { toast } from '@/shared/hooks/use-toast';
import { ApiError } from '@/shared/services/apiConfig';
import { logger } from '@/shared/utils/logger';

/**
 * Toast utility functions for simplified success and error notifications
 */

/**
 * Shows a success toast notification
 * @param message - The success message to display
 * @param title - Optional title (defaults to "Success")
 */
export const showSuccess = (message: string, title: string = "Success") => {
  logger.success(message, title, 'toast-utils');
  toast({
    title,
    description: message,
    variant: "success",
  });
};

/**
 * Shows an error toast notification
 * @param message - The error message to display
 * @param title - Optional title (defaults to "Error")
 */
export const showError = (message: string, title: string = "Error") => {
  logger.error(message, title, 'toast-utils');
  toast({
    title,
    description: message,
    variant: "destructive",
  });
};

// export const showErrorWithApiError = (error: any | ApiError, defaultMessage: string = ERROR.DEFAULT, title: string = "Error") => {
//     const errorMessage = (error instanceof ApiError && error.message) ? error.message : (error as Error).message || defaultMessage;
//     showError(errorMessage, title);
//   };

export const showErrorWithApiError = (error: any, defaultMessage: string, title: string = "Error") => {
  let rawMessage = defaultMessage;

  if (error instanceof ApiError) {
    if (error.body?.error?.message) {
      rawMessage = error.body.error.message;
    } else if (error.message) {
      rawMessage = error.message;
    }
  } else if (error?.message) {
    rawMessage = error.message;
  }

  showError(rawMessage, title);

  /*
    const sanitized = sanitizeErrorMessage(rawMessage, defaultMessage);
    const displayMessage =
      error instanceof ApiError && sanitized === defaultMessage && error.status
        ? getErrorMessageFromCode(error.status, defaultMessage)
        : sanitized;
  
    showError(displayMessage, title);
    */
};

/**
 * Shows a warning toast notification
 * @param message - The warning message to display
 * @param title - Optional title (defaults to "Warning")
 */
export const showWarning = (message: string, title: string = "Warning") => {
  toast({
    title,
    description: message,
    variant: "default",
  });
};

/**
 * Shows an info toast notification
 * @param message - The info message to display
 * @param title - Optional title (defaults to "Info")
 */
export const showInfo = (message: string, title: string = "Info") => {
  toast({
    title,
    description: message,
    variant: "default",
  });
};

/**
 * Toast utility object with success and error methods
 */
export const toastUtils = {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo,
};

// Default export for convenience
export default toastUtils; 